import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import formatter from '../utils/formatter-util';

export interface FormatterProps {
  format?: string;
  value: string;
  mobileDateFormat?: string;
  type?: 'date' | 'number' | 'text' | 'card' | 'bankaccount' | 'phone';
  credit?: boolean;
  inputFormat?: string;
  delimiter?: string;
  delimitedAt?: number;
}

export default function Formatter(props: FormatterProps) {
  const resizeEvents = useRef(0);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const listener = () => {
      resizeEvents.current += 1;
      // Set the state on every other listener call
      if (resizeEvents.current % 2 === 0) {
        setWindowWidth(window.innerWidth);
      }
      if (resizeEvents.current === 4) {
        resizeEvents.current = 0;
      }
    };
    if (
      props.mobileDateFormat &&
      window.addEventListener &&
      window.removeEventListener
    ) {
      window.addEventListener('resize', listener);

      return () => window.removeEventListener('resize', listener);
    }
    return undefined;
  }, []);

  return <>{formatter({ ...props, windowWidth })}</>;
}
